import { Stack } from '@mui/material';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import HeaderNav from './nav/HeaderNav';

const Header = () => {
    const location = useLocation();

    return (
        <div id="header" className="header">
            <Stack
                direction="column"
                spacing={6}
                sx={{
                    justifyContent: { xs: 'flex-start', md: 'space-between' },
                    alignItems: { xs: 'center', md: 'center' },
                }}
            >
                <Stack
                    spacing={1.4}
                    direction="column"
                    sx={{ alignItems: { xs: 'center', md: 'center' } }}
                >
                    <Link 
                        to="/" 
                        state={{ from: location.pathname }}
                    >
                        <div className="logo" role="img" aria-label="Yulian Kraynyak" />
                    </Link>
                </Stack>
                <HeaderNav />
            </Stack>
        </div>
    );
};

export default Header;
